import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { FromIRBMatchGenDocQueueContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_from_irb_match_gen_doc_queue_container.model';
@Injectable({
  providedIn: 'root'
})
export class FromIRBMatchGenDocQueueService extends BaseApiTemplateService<FromIRBMatchGenDocQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/from-irb-match-gen-doc-queues/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/from-irb-match-gen-doc-queues/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/from-irb-match-gen-doc-queues/backoffice-ep'
    this.httpClient = http;
  }
}
